import React from 'react';
import { Link } from 'react-router-dom';
export default ({ category, site }) => {
    return <>
        <Link to={`/category/${category}/${site}`}>
            <div className="app">
                <span className="icon kcate" ></span>
                <span className="label" >Category</span>
            </div>
        </Link >
        <Link to={`/siteApp/${category}/${site}/kaizen/admin/area`}>
            <div className="app" >
                <span className="icon karea" ></span>
                <span className="label" style={{ paddingTop: "5px" }}>Area</span>
            </div>
        </Link >
        <Link to={`/siteApp/${category}/${site}/kaizen/admin/cell`}>
            <div className="app">
                <span className="icon kcell" ></span>
                <span className="label" >Cell</span>
            </div>
        </Link >
        <Link to={`/siteApp/${category}/${site}/kaizen/admin/line`}>
            <div className="app">
                <span className="icon kline" ></span>
                <span className="label" style={{ paddingTop: "5px" }}>Line</span>
            </div>
        </Link >
        <Link to="#"><div className="app">
            <span className="icon kusers" ></span>
            <span className="label" >Site Users</span>
        </div>
        </Link >
        <Link to={`/siteApp/${category}/${site}/kaizenAdmin/nominatedKaizen`}><div className="app">
            <span className="icon krecog" ></span>
            <span className="label" >Nominated Kaizen</span>
        </div>
        </Link >
        <Link to={`/siteApp/${category}/${site}/kaizen/delete-kaizen`}><div className="app">
            <span className="icon kdel" ></span>
            <span className="label" >Delete Kaizen</span>
        </div>
        </Link ></>
}
